import { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { MDSTypography } from '@marqvision/mds-v2';
import { MDSHighlightedText } from '@marqvision/mds/core';

const useStyles = makeStyles(({ color }) => ({
  descriptionWrapper: {
    padding: '8px 12px',
    border: `1px solid ${color.border.neutral.default.normal}`,
    borderRadius: '4px',

    overflowX: 'hidden',
    overflowY: 'auto',
  },
}));

type Props = {
  minHeight?: string;
  maxHeight?: string;
  endIndex?: number | null;
  startIndex?: number | null;
  text: string;
  isDisabled?: boolean;
  className?: string;
};

export const ScrollableDescription = (props: Props) => {
  const classes = useStyles();
  const { minHeight = '64px', maxHeight = '64px', isDisabled, text, startIndex, endIndex, className } = props;

  const descriptionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const descriptionElement = descriptionRef.current;
    const highlightedTextElement = descriptionElement?.querySelector('span');

    if (descriptionElement && highlightedTextElement) {
      const parentElementPositionY = descriptionElement.getBoundingClientRect().top;
      const scrollPositionY = highlightedTextElement.getBoundingClientRect().top;
      const relativeTop = scrollPositionY - parentElementPositionY;

      if (highlightedTextElement) {
        descriptionElement.scrollTo({ top: relativeTop, behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <div ref={descriptionRef} className={clsx(classes.descriptionWrapper)} style={{ minHeight, maxHeight }}>
      <MDSTypography
        variant="body"
        size="m"
        weight="regular"
        color={`color/content/neutral/${isDisabled ? 'secondary/normal' : 'default/normal'}`}
        wordBreak="break-all"
        className={className}
      >
        <MDSHighlightedText text={text} startIndex={startIndex} endIndex={endIndex} />
      </MDSTypography>
    </div>
  );
};
